import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

type TabProps = {
  $active?: boolean;
};

export const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Tab = styled.div<TabProps>`
  padding-block: 6px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;

  border-radius: 4px;

  background: ${props => (props.$active ? "#4585FF" : "#BBBBBB")};

  a {
    color: inherit;
    text-decoration: none;
  }
`;
